import * as React from 'react';

import { Viewer } from 'lib/api/recipients/types';
import { Button } from 'react-covideo-common';
import { NewModal } from 'lib/components/modal/NewModal';
import { ParagraphNormal } from 'lib/components/styles/typography';
import { Flex } from 'lib/components/styles/layout';

type Props = {
  handleModalClose: (block?: boolean) => void;
  recepient: Viewer;
};

export const ModalBlockRecepient = ({ handleModalClose, recepient }: Props) => {
  return (
    <NewModal
      headerText={'Block recipient?'}
      hideHeader={false}
      closeModalOnBackdropOrEscPress={true}
      closeModal={() => handleModalClose(false)}
      style={{
        content: {
          paddingLeft: '32px',
        },
      }}
    >
      <>
        <ParagraphNormal>
          {'Are you sure you want to block the recipient (' +
            recepient.email +
            ')?'}
        </ParagraphNormal>
        <Flex
          flexDirection='row'
          width='100%'
          gap='16px'
          justifyContent='flex-end'
          margin='32px 0 0 0'
        >
          <Button
            variant='secondary'
            text={'No, Cancel'}
            onClick={() => handleModalClose(false)}
          />
          <Button
            variant='destructive'
            text={'Yes, Block'}
            onClick={() => handleModalClose(true)}
          />
        </Flex>
      </>
    </NewModal>
  );
};
